// extracted by mini-css-extract-plugin
export default {"reactions":"dSjvEifT","label":"r1VaAHHI","input":"WtI3CHjP","content":"Wsj3WIfJ","count":"RpHXpKyt"};